export interface FlagDefinition {
  default: boolean;
  description: string;
}

export const FLAGS = {
  chatsV2: {
    default: false,
    description: 'Enable the new chat experience (WIP).',
  },
} as const satisfies Record<string, FlagDefinition>;

export type FlagName = keyof typeof FLAGS;
export type FlagsState = Record<FlagName, boolean>;

export const DEFAULT_FLAGS: FlagsState = Object.fromEntries(
  (Object.entries(FLAGS) as [FlagName, FlagDefinition][]).map(([name, def]) => [name, def.default]),
) as FlagsState;
